<template>
  <div>
    <header-index></header-index>
    <div class="body">
      <div class="image_area">
        <div class="resolution">
          <div class="proportion">
            <span>图片比例</span>
            <span>Proportion</span>
          </div>
          <div class="example">
            <div class="lineone" @click="handleclick">
              <div class="res1 box" @click="selectresolution(1)">
                <div></div>
                <span>21 : 9</span>
              </div>
              <div class="res2 box" @click="selectresolution(2)">
                <div></div>
                <span>16 : 9</span>
              </div>
              <div class="res3 box" @click="selectresolution(3)">
                <div></div>
                <span>3 : 2</span>
              </div>
              <div class="res4 box" @click="selectresolution(4)">
                <div></div>
                <span>4 : 3</span>
              </div>
              <div class="res5 box" @click="selectresolution(5)">
                <div></div>
                <span>1 : 1</span>
              </div>
            </div>
            <div class="linetwo" @click="handleclick">
              <div class="res6 box" @click="selectresolution(6)">
                <div></div>
                <span>3 : 4</span>
              </div>
              <div class="res7 box" @click="selectresolution(7)">
                <div></div>
                <span>2 : 3</span>
              </div>
              <div class="res8 box" @click="selectresolution(8)">
                <div></div>
                <span>9 : 16</span>
              </div>
              <div class="res9 box" @click="selectresolution(9)">
                <div></div>
                <span>1600px</span>
              </div>
              <div class="res10 box active" @click="selectresolution(10)">
                <div></div>
                <span>默认</span>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="title_tips">
              <div>图片尺寸</div>
              <span>Sizes</span>
            </div>
            <div class="wh">
              <div class="width">
                <div>宽度</div>
                <input type="number" v-model="width" disabled="false">
              </div>
              <div class="icon iconfont">&#xe642;</div>
              <div class="height">
                <div>高度</div>
                <input type="number" v-model="height" disabled="false">
              </div>
            </div>
          </div>
          <div class="result">
            <div class="result_tips iconfont">&#xe624; 预计生成内容</div>
            <div class="tips_img">
              <div>
                <img
                  src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/morejoy/ComfyUI_temp_prape_00003_.png"
                  alt="加载图像失败">
              </div>
              <div>
                <img
                  src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/morejoy/ComfyUI_temp_prape_00006_.png"
                  alt="加载图像失败">
              </div>
            </div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="parameters">
          <div class="tips iconfont">&#xe604;&nbsp;&nbsp;正向提示词[Positive]</div>
          <div class="positive">
            <div class="translate iconfont" v-if="translate === true" @click="toggleTranslate">&#xebe2;</div>
            <div class="translate iconfont" v-else @click="toggleTranslate">&#xebe0;</div>
            <textarea name="" id="" placeholder="请输入要修改的内容加以引导" v-model="positive"></textarea>
          </div>
          <div class="other iconfont">&#xe60b;&nbsp;&nbsp;其他参数</div>
          <div class="weight">
            <div class="iconfont">&#xe61a; Ksampler应用强度</div>
            <input type="number" v-model="weight" min="0.00" max="1.00">
          </div>
          <div class="guidance">
            <div class="iconfont">&#xe84c; Ksampler引导系数</div>
            <input type="number" v-model="guidance" min="0.00" max="100.00">
          </div>
          <div class="steps">
            <div class="iconfont">&#xe648; Ksampler采样步数</div>
            <input type="number" v-model="steps" min="0" max="35">
          </div>
          <div class="start iconfont" @click="start_process">&#xe632; 开始任务</div>
          <div class="disscuss_area">
            <div class="disscuss iconfont" @click="handelDissvisible(1)">&#xe67c; 讨论区</div>
            <div class="disscuss iconfont" @click="handelDissvisible(2)">&#xe66c; 返图区</div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="panel">
          <div class="show iconfont">&#xe76d; 显示面板</div>
          <img v-if="processedImage" :src="processedImage" alt="">
          <div class="copy_path iconfont" title="复制图像地址" @click="copy_path(processedImage)">&#xe660; 复制</div>
          <div v-if="tips" class="tips">{{ this.tips }}</div>
          <div v-if="tips" class="mask"></div>
        </div>
      </div>
    </div>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>

import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart } from '@/api/user'
// import { T_SD_TTI } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'
import theme from '@/utils/theme'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
export default {
  name: 'MoreJoy',
  data() {
    return {
      imageSrc: '',
      imagePath: '',
      processedImage: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',
      describe: '',
      width: 512,
      height: 768,
      steps: 15,
      weight: 1.00,
      guidance: 3.5,
      positive: null,
      english: 'Ice,a bottle of cosmetics is on the ice with ice chips scattered around,still life,from above,no humans,best quality,High Quality,realistic,RAW photo,masterpiece,8k,insane details,High detail,hyperdetailed,Lighting,Master Lighting,film grain,',
      chinese: '一瓶石上精华，写着文字"MoreJoy",水，聚焦精华，周围有许多花朵，明亮的暖色调，真实的摄影，高分辨率，清晰的精华结构，整体画面是冷色调的，天空色。',
      translate: true,
      day: theme.day,
      night: theme.night,
      theme: true,
      genid: 'ai/d/t/moreJoy',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null
    }
  },
  created() {
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
    this.imagePath = localStorageUtils.getItem('morejoy') || ''
    // this.processedImage = localStorageUtils.getItem('morejoyshowimage') || ''
    if (this.translate === false) {
      this.positive = this.english
    }
    if (this.translate === true) {
      this.positive = this.chinese
    }
    // 将ID值赋给讨论区类型
    this.disscussType = 'ai/d/t/moreJoy'
  },
  mounted() {
    this.source_html()
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 修改dissboard的状态
    handelDissvisible(x) {
      if (x === 1) {
        this.boardvisible = true
      }
      if (x === 2) {
        Message.warning('😋开发者功能暂未开放,敬请期待~!')
      }
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 复制图像地址
    async copy_path(path) {
      if (!path) {
        Message.error('图像地址为空,请确认是否生成图像！')
        return
      }
      try {
        // 不兼容已弃用
        // await navigator.clipboard.writeText(path)

        // 兼容性更好
        const textarea = document.createElement('textarea')
        textarea.value = path
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('复制内容成功,可进行下一步操作！')
      } catch {
        Message.error('复制内容失败,请稍后再试！')
      }
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + D
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault() // 阻止默认行为（可选）
        this.start_process() // 执行返回主页的操作
      }
    },
    // 切换翻译状态
    toggleTranslate() {
      this.translate = !this.translate
      if (this.translate) {
        this.positive = this.chinese
        Message.success('已开启翻译模式,请用中文输入模式！')
      } else {
        this.positive = this.english
        Message.success('已关闭翻译模式,请用英文输入模式！')
      }
    },
    // 选分辨率
    selectresolution(x) {
      const resolution = {
        1: { width: 1536, height: 657 },
        2: { width: 1280, height: 720 },
        3: { width: 1536, height: 1024 },
        4: { width: 2048, height: 1536 },
        5: { width: 1024, height: 1024 },
        6: { width: 1536, height: 2048 },
        7: { width: 1024, height: 1536 },
        8: { width: 720, height: 1280 },
        9: { width: 1600, height: 1600 },
        10: { width: 512, height: 768 }
      }
      this.width = resolution[x].width
      this.height = resolution[x].height
      Message.success('已选定图像比例模式,可以开始任务！')
    },
    handleclick(event) {
      const target = event.target.closest('.box')
      if (!target) return
      // 获取所有需要操作的容器
      const containers = document.querySelectorAll('.lineone, .linetwo')
      // 遍历每个容器，移除其中所有 .box 的 active 类
      containers.forEach(container => {
        container.querySelectorAll('.box').forEach(item => {
          item.classList.remove('active')
        })
      })
      // 给当前点击的元素添加 active 类
      target.classList.add('active')
    },
    // 应用函数
    start_process() {
      const GEN_ID = this.genid
      this.processedImage = ''
      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      const seed = Math.floor(Math.random() * 100000000000000)
      // const prompt = this.describe
      this.processing = true
      this.tips = '任务正在生成, 预计等待25S-40S.....'
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const promptData = {
        5: {
          inputs: {
            width: this.width,
            height: this.height,
            batch_size: 1
          },
          class_type: 'EmptyLatentImage',
          _meta: {
            title: '空潜空间图像'
          }
        },
        6: {
          inputs: {
            text: [
              '54',
              0
            ],
            clip: [
              '16',
              0
            ]
          },
          class_type: 'CLIPTextEncode',
          _meta: {
            title: 'CLIP文本编码（提示）'
          }
        },
        8: {
          inputs: {
            samples: [
              '33',
              0
            ],
            vae: [
              '18',
              0
            ]
          },
          class_type: 'VAEDecode',
          _meta: {
            title: 'VAE解码'
          }
        },
        15: {
          inputs: {
            unet_name: '一站式电商大模型-场景-产品-主图_FLUX版.safetensors',
            weight_dtype: 'fp8_e4m3fn'
          },
          class_type: 'UNETLoader',
          _meta: {
            title: '加载扩散模型'
          }
        },
        16: {
          inputs: {
            clip_name1: 'clip_l.safetensors',
            clip_name2: 't5xxl_fp8_e4m3fn.safetensors',
            type: 'flux'
          },
          class_type: 'DualCLIPLoader',
          _meta: {
            title: '双CLIP加载器'
          }
        },
        18: {
          inputs: {
            vae_name: 'FLUX.1-vae.sft'
          },
          class_type: 'VAELoader',
          _meta: {
            title: '加载VAE'
          }
        },
        33: {
          inputs: {
            seed: [
              '36',
              0
            ],
            sampler: 'euler',
            scheduler: 'simple',
            steps: this.steps,
            guidance: this.guidance,
            max_shift: '',
            base_shift: '',
            denoise: '1.0',
            model: [
              '15',
              0
            ],
            conditioning: [
              '6',
              0
            ],
            latent_image: [
              '5',
              0
            ]
          },
          class_type: 'FluxSamplerParams+',
          _meta: {
            title: '🔧 Flux Sampler Parameters'
          }
        },
        35: {
          inputs: {
            seed: seed
          },
          class_type: 'ttN seed',
          _meta: {
            title: 'seed'
          }
        },
        36: {
          inputs: {
            X: [
              '35',
              0
            ],
            tips: '整数变量X'
          },
          class_type: 'Math_X变量值',
          _meta: {
            title: 'Math_X变量值'
          }
        },
        37: {
          inputs: {
            images: [
              '8',
              0
            ]
          },
          class_type: 'PreviewImage',
          _meta: {
            title: '预览图像'
          }
        },
        47: {
          inputs: {
            filename: filename,
            access_key_id: OSS_ACCESS_KEY_ID,
            access_key_secret: OSS_ACCESS_KEY_SECRET,
            security_token: '',
            bucket_name: 'mj-comfy-ui',
            endpoint: 'oss-cn-shenzhen.aliyuncs.com',
            image: [
              '8',
              0
            ]
          },
          class_type: 'OSSUploadNode',
          _meta: {
            title: '保存图片到oss'
          }
        },
        52: {
          inputs: {
            text: this.positive,
            translate_from: 'zh',
            translate_to: 'en',
            APIID: '20250612002379955',
            APIKEY: BAIDU_TRANSLATE_API_KEY
          },
          class_type: 'AC_百度翻译',
          _meta: {
            title: 'AC_百度翻译'
          }
        },
        54: {
          inputs: {
            boolean: this.translate,
            on_true: [
              '52',
              0
            ],
            on_false: [
              '55',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        55: {
          inputs: {
            text: this.positive
          },
          class_type: 'Nodepad_啊程记事本',
          _meta: {
            title: 'Nodepad_啊程记事本'
          }
        }
      }
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          this.processing = false
          this.tips = false
          return null
        }
      }

      const fetchImageFilename = async (promptId) => {
        try {
          // 直接使用该实例请求历史记录
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          // const response = await getImagePathByPrompt(promptId)
          // const promptInfo = response[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 47 // prompt信息组件名的下标

          console.log(promptInfo)
          if (promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)

            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('morejoyshowimage', imagepath)
            this.getTaskEnd(imagepath, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
          } else {
            console.error('获取历史记录失败，状态码：', response.status)
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
        }
      }

      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: GEN_ID
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              // const tmp = JSON.parse(data)
              // console.log(`这是返回${msg}`)
              // console.log(tmp)

              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  // console.log('执行完成')
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
                // console.log(`大约完成：${current}%`)
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
            }
          }
        }
        this.ws.onclose = async () => {
          // console.log('与后台链接断开')
          this.processing = false
          this.tips = false
          try {
            // 恢复cuda为空闲状态
            const index = cudaIndexNum()
            // console.log('回复当前cuda状态', index)
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }

      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    async getTaskEnd(tmp, taskLogId) {
      const imgInfo = await getImageSizeByLoading(tmp)
      const info = {
        details: [{ path: tmp, imgInfo: imgInfo }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 初始化效果
    source_html() {
      const html = document.querySelector('html')
      // 夜间要切换的元素
      // 左侧导航
      const navigation = document.querySelectorAll('.navigation .nav-item')
      // 右边页面
      const right_menu = document.querySelectorAll('.image_area')
      // 精品应用
      const delecacy = document.querySelector('.delicacy_title')

      // 风格样式
      const type_list = document.querySelector('.typeof')

      // 标题栏
      const header = document.querySelector('header')

      // 侧边栏
      const left = document.querySelector('.left_menu')

      // 搜索框
      const serarch = document.querySelector('.search')

      // 实验室
      const light = document.querySelector('.light')

      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      if (this.theme === false) {
        html.style.backgroundColor = this.night
        try {
          navigation.forEach(element => {
            element.style.color = 'gray'
          })
          right_menu.forEach(element => {
            element.style.opacity = 0.75
          })
          delecacy.style.color = 'gray'
          type_list.style.color = 'gray'
          type_list.childNodes.forEach(element => {
            element.style.color = 'gray'
          })
          header.style.borderBottom = '1px solid gray'
          left.style.borderRight = '1px solid gray'
          serarch.childNodes[0].style.border = '1px solid gray'
          light.children[0].style.color = 'gray'

          label.style.paddingLeft = '60%'
          darktips.style.opacity = 1
        } catch (error) {
        }
      } else {
        html.style.backgroundColor = this.day
        try {
          navigation.forEach(element => {
            element.style.color = ''
          })
          right_menu.forEach(element => {
            element.style.opacity = 1
          })
          delecacy.style.color = ''
          type_list.style.color = ''
          type_list.childNodes.forEach(element => {
            element.style.color = ''
          })

          header.style.borderBottom = ''
          left.style.borderRight = ''
          serarch.childNodes[0].style.border = ''
          light.children[0].color = 'black'

          label.style.paddingLeft = '4%'
          darktips.style.opacity = 0
        } catch (e) {
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

header {
  height: 95px;
  width: 2560px;
  padding: 10px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid @basicselect;

  .title {
    display: flex;
    color: @font_black;
    align-items: center;

    div {
      width: 450px;
      height: 60px;
      display: flex;
      align-items: center;
      padding: 10px;

      img {
        width: 180px;
        object-fit: cover
      }
    }

    .none {
      width: 1915px;
    }

    .back {
      display: flex;
      justify-content: center;
      width: 160px;
      height: 60px;
      background-color: @morejoy;
      color: @font_white;
      border-radius: @border_radius;
      cursor: pointer;
      transition: all 0.5s;
      font-size: 21px;

      &:hover {
        scale: 1.05;
        transition: all 0.5s;
      }
    }
  }
}

.active {
  background-color: rgb(254, 228, 208) !important;

  div {
    border: 1px solid rgb(252, 119, 22) !important;
    background-color: rgb(253, 206, 170) !important;
  }

  span {
    color: rgb(252, 119, 22) !important;
  }
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  overflow-y: scroll;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .title {
    display: flex;
    height: 90px;
    line-height: 80px;
    justify-content: center;
    padding: 0 10px;
    padding-top: 10px;

    div {
      flex: 1;
      font-size: 25px;
      color: @font_black;
      text-align: center;
      cursor: pointer;
      border-radius: @border_radius;
      border: 2px solid transparent;

      &:hover {
        border: 2px dashed @basicselect;
        transition: all 0.5s;
      }
    }
  }

  .image_area {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    height: calc(100vh - 95px);
    padding: 10px 30px 10px 30px;

    .gap {
      width: 15px;
    }

    .resolution {
      position: relative;
      flex: 1;
      flex-direction: column;
      height: 100%;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.5s;
      color: @font_gray;

      .proportion {
        display: flex;
        height: 40px;
        font-size: 25px;
        color: @font_gray;
        gap: 0 20px;

        span:nth-child(2) {
          color: rgb(185, 185, 185);
          font-size: 22px;
        }
      }

      .example {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 420px;
        border: 2px solid @basicselect;
        border-radius: @border_radius;
        padding: 15px;
        gap: 10px 10px;

        .lineone,
        .linetwo {
          width: 100%;
          display: flex;
          gap: 0 10px;

          .res1,
          .res2,
          .res3,
          .res4,
          .res5,
          .res6,
          .res7,
          .res8,
          .res9,
          .res10 {
            width: 150px;
            height: 185px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-color: @basicselect;
            border-radius: @border_radius;
            gap: 15px;
            transition: all 0.5s;

            &:hover {
              transition: all 0.5s;
              box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
            }

            div {
              width: 95px;
              height: 40px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
            }
          }

          .res2 {
            div {
              width: 75px;
              height: 40px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
            }
          }

          .res3 {
            div {
              width: 55px;
              height: 40px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
            }
          }

          .res4 {
            div {
              width: 50px;
              height: 40px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
            }
          }

          .res5 {
            div {
              width: 40px;
              height: 40px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
            }
          }

          .res6,
          .res7,
          .res8,
          .res9,
          .res10 {
            position: relative;
          }

          .res6 {
            div {
              position: absolute;
              bottom: 70px;
              width: 40px;
              height: 45px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
              position: absolute;
              bottom: 30px;
            }
          }

          .res7 {
            div {
              position: absolute;
              bottom: 70px;
              width: 40px;
              height: 55px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
              position: absolute;
              bottom: 30px;
            }
          }

          .res8 {
            div {
              position: absolute;
              bottom: 70px;
              width: 40px;
              height: 75px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
              position: absolute;
              bottom: 30px;
            }
          }

          .res9 {
            div {
              position: absolute;
              bottom: 70px;
              width: 55px;
              height: 55px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
              position: absolute;
              bottom: 30px;
            }
          }

          .res10 {
            div {
              position: absolute;
              bottom: 70px;
              width: 40px;
              height: 65px;
              border-radius: @border_radius_3;
              border: 1px solid @font_gray;
              background-color: @back_gray;
            }

            span {
              color: @font_black;
              font-size: 25px;
              position: absolute;
              bottom: 30px;
            }
          }

        }
      }

      .detail {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 125px;
        padding: 10px 0px;

        .title_tips {
          display: flex;
          width: 100%;
          height: 55px;
          gap: 0 20px;
          margin-bottom: 5px;

          div {
            font-size: 25px;
            color: @font_gray;
          }

          span {
            font-size: 25px;
            color: rgb(185, 185, 185);
          }
        }

        .wh {
          width: 100%;
          height: 125px;
          display: flex;
          transition: all 0.5s;

          .width,
          .height {
            display: flex;
            flex: 50%;
            height: 60px;
            align-items: center;
            border: 2px solid @basicselect;
            border-radius: @border_radius_2;
            background-color: rgb(245, 247, 250);

            div {
              width: 70px;
              height: 60px;
              font-size: 22px;
              color: @font_gray;
              padding: 10px;
              border-right: 2px solid @basicselect;
            }

            input {
              height: 100%;
              width: 300px;
              padding: 10px;
              outline: none;
              border: none;
              color: @font_gray;
              font-size: 20px;
              background-color: rgb(245, 247, 250);
            }
          }

          .icon {
            font-size: 35px;
            color: rgb(185, 185, 185);
            line-height: 35px;
            padding: 10px;
          }
        }
      }

      .result {
        width: 100%;
        height: calc(100vh - 700px);
        background-color: @basicselect;
        border-radius: @border_radius_2;
        padding: 10px 10px;

        .result_tips {
          font-size: 25px;
          color: @font_gray;
          margin-bottom: 5px;
        }

        .tips_img {
          display: flex;
          gap: 10px;

          div {
            flex: 0.5;
            height: 520px;
            border-radius: @border_radius_2;
            overflow: hidden;
            transition: all 0.5s;

            img {
              height: 100%;
              width: 100%;
              transition: all 0.5s;

              &:hover {
                transition: all 0.5s;
                scale: 1.05;
              }
            }
          }
        }
      }
    }

    .parameters {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      border-radius: 25px;
      align-items: center;
      height: calc(100vh - 160px);
      font-family: 'icomoon';
      gap: 10px 0;
      justify-content: center;

      .tips {
        width: 700px;
        font-size: 25px;
        color: @font_gray;
      }

      .positive {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 700px;
        height: 280px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border: 1px solid @basicselect;
        border-radius: @border_radius;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        .translate {
          position: absolute;
          right: 25px;
          bottom: 15px;
          font-size: 25px;
          color: @font_gray;
          cursor: pointer;
          transition: all 0.5s;
        }

        textarea {
          width: 100%;
          height: 100%;
          resize: none;
          font-size: 20px;
          border: none;
          border-radius: @border_radius;
          padding: 20px;
          line-height: 25px;
          color: @font_gray;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
        }

        &:active {
          // line-height: 60px;
          width: 730px;
          height: 280px;
          transition: all 0.5s;
        }
      }

      .top_tips {
        color: @font_gray;
        width: 700px;
        font-size: 24px;
        text-indent: 10px;
      }

      .other {
        font-size: 25px;
        width: 700px;
        color: @font_gray;
        text-align: left;
      }

      .guidance,
      .weight,
      .steps {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 700px;
        height: 100px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: 15px;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        input {
          width: 380px;
          height: 35px;
          font-size: 20px;
          border: 1px solid @basicselect;
          border-radius: 5px;
          text-align: center;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 730px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .start {
        width: 700px;
        height: 100px;
        font-size: 25px;
        text-align: center;
        line-height: 100px;
        font-family: 'icomoon';
        border-radius: @border_radius;
        background-color: @basicselect;
        color: @font_black;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 730px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .disscuss_area {
        display: flex;
        width: 700px;
        height: 100px;
        gap: 10px;

        .disscuss {
          flex: 1;
          height: 100px;
          font-size: 25px;
          border-radius: @border_radius;
          background-color: @basicselect;
          text-align: center;
          line-height: 100px;
          color: @font_black;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            font-size: 27px;
            transition: all 0.5s;
            box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

          }
        }
      }
    }

    .panel {
      height: 100%;
      position: relative;
      flex: 1;
      border-radius: 25px;
      background-color: @basicselect;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .show {
        position: absolute;
        border-radius: @border_radius;
        background-color: @morejoy;
        width: 200px;
        height: 60px;
        font-size: 25px;
        text-align: center;
        line-height: 60px;
        top: 25px;
        left: 25px;
        z-index: 5;
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .tips {
        position: absolute;
        width: 100%;
        height: 50px;
        font-size: 25px;
        top: 50%;
        left: 6%;
        text-align: center;
        line-height: 100%;
        transition: all 0.5s;
        color: @font_black;
        font-weight: 500;
        z-index: 4;
      }

      .mask {
        width: 100%;
        height: 100%;
        background-color: @font_gray;
        z-index: 3;
      }

      .copy_path {
        position: absolute;
        text-align: center;
        right: 10px;
        bottom: 10px;
        width: 120px;
        height: 50px;
        font-size: 25px;
        color: @font_gray;
        z-index: 4;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
        }
      }
    }
  }
}
</style>
